module.exports = __webpack_public_path__ + "img/malam-payroll-logo.fe181dfd.svg";